module.exports = __webpack_public_path__ + "img/img_core_4.b009d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_core_4.png
// module id = ijeQ
// module chunks = 1